/**
 * Thrown when a target element was expected but not received
 */
export class MissingTargetError extends Error {
	public constructor() {
		super("Target element is not specified");
	}
}

/**
 * Thrown when incorrect arguments are recieved
 */
export class InvalidArgumentsError extends Error {
	public constructor(args: string[]) {
		super(`Invalid arguments: ${args.join(", ")}`);
	}
}
